import MenuCategory from "../../components/MenuCategory/MenuCategory";
import MenuHeaderCategory from "../../components/MenuCategory/MenuHeaderCategory";
import useAppMenuRoutes from "../../router/useAppMenuRoutes";

function Home() {
  const categories = useAppMenuRoutes();

  return (
    <div className="grid grid-cols-1 gap-6 px-3 pb-6 md:grid-cols-2 xl:grid-cols-3">
      {categories.map(
        (
          {
            color,
            subtitle,
            subtitleValue,
            title,
            icon,
            categories,
            navigationLinks,
          },
          index,
        ) => {
          return (
            <MenuCategory
              key={index}
              categories={categories}
              className="!mx-0 !mb-0 w-full"
              MenuHeaderCategory={
                <MenuHeaderCategory
                  title={title}
                  icon={icon}
                  color={color}
                  subtitle={subtitle}
                  subtitleValue={subtitleValue}
                  navigationLinks={navigationLinks}
                />
              }
            />
          );
        },
      )}
    </div>
  );
}

export default Home;
